module.exports = __webpack_public_path__ + "static/media/allforone_onwr-logo-small.99b32b0f.png";